import { render, staticRenderFns } from "./DoneOrdersByModality.vue?vue&type=template&id=89d672e8"
import script from "./DoneOrdersByModality.vue?vue&type=script&lang=js"
export * from "./DoneOrdersByModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports